// extracted by mini-css-extract-plugin
export default {"icon":"SidebarIcon_icon__zWMw+","iconSm":"SidebarIcon_iconSm__Bz2JS","iconMuted":"SidebarIcon_iconMuted__814qs"};